function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"])
    return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r))
    return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
    var o, i = p[t], d = G.p, l = i[2];
    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
} if (o || r > 1)
    return a; throw y = !0, n; } return function (o, p, l) { if (f > 1)
    throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
    try {
        if (f = 2, i) {
            if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u)))
                    throw TypeError("iterator result is not an object");
                if (!t.done)
                    return t;
                u = t.value, c < 2 && (c = 0);
            }
            else
                1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
            i = e;
        }
        else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a)
            break;
    }
    catch (t) {
        i = e, c = 1, u = t;
    }
    finally {
        f = 1;
    }
} return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() { } function GeneratorFunction() { } function GeneratorFunctionPrototype() { } t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try {
    i({}, "", {});
}
catch (e) {
    i = 0;
} _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try {
    var i = n[a](c), u = i.value;
}
catch (n) {
    return void e(n);
} i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton, MenuItem, Select, FormControl, InputLabel, Chip, Alert, Stack, CircularProgress } from '@mui/material';
import { Add as AddIcon, ListAltOutlined as EditIcon, DeleteOutlined as DeleteIcon, FilterListOutlined as FilterIcon } from '@mui/icons-material';
import RoleModal from '../components/RoleModal';
import { ConfirmationDialog } from '../components/ConfirmationDialog';
import { UserAPI } from '../apis/UserAPI';
import { isAuthorized } from '../utils/utilities';
import authenticatedRoute from '../views/AuthenticatedRoute';
import { constants } from '../constants';
import { useThemeDetails } from '../components/ThemeDetailsContext';
// Helper function to validate role update requirements
var validateRoleForUpdate = function validateRoleForUpdate(role) {
    return !!(role.application_id && role.role_key && role.organization_id && role.id);
};
// Helper function to normalize application_id to string array
var normalizeAppIds = function normalizeAppIds(appId) {
    if (!appId)
        return [];
    if (Array.isArray(appId))
        return appId.map(String);
    if (typeof appId === 'string' && appId.includes(',')) {
        return appId.split(',').map(function (id) {
            return id.trim();
        });
    }
    return [String(appId)];
};
// Helper function to format role date from metadata
var formatRoleDate = function formatRoleDate(metadata) {
    var dateOptions = {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
    };
    if (!metadata)
        return 'Unknown';
    if ('createdDate' in metadata && typeof metadata.createdDate === 'string' && metadata.createdDate) {
        return new Date(metadata.createdDate).toLocaleDateString('en-US', dateOptions);
    }
    if ('updatedDate' in metadata && typeof metadata.updatedDate === 'string' && metadata.updatedDate) {
        return new Date(metadata.updatedDate).toLocaleDateString('en-US', dateOptions);
    }
    return 'Unknown';
};
// Helper function to handle policy updates for existing roles
var handleExistingRolePolicyUpdates = /*#__PURE__*/ function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee(roleData, selectedRole, policies) {
        var currentPoliciesResponse, currentPolicyNames, policiesToAdd, policiesToRemove, policyIdsToAdd, policyIdsToRemove;
        return _regenerator().w(function (_context) {
            while (1)
                switch (_context.n) {
                    case 0:
                        if (!(!roleData.policies || !selectedRole.id)) {
                            _context.n = 1;
                            break;
                        }
                        return _context.a(2);
                    case 1:
                        _context.n = 2;
                        return UserAPI.getRolePolicies(selectedRole.id);
                    case 2:
                        currentPoliciesResponse = _context.v;
                        currentPolicyNames = currentPoliciesResponse.resource.map(function (p) {
                            return p.name;
                        }); // Find policies to add and remove
                        policiesToAdd = roleData.policies.filter(function (p) {
                            return !currentPolicyNames.includes(p);
                        });
                        policiesToRemove = currentPolicyNames.filter(function (p) {
                            return !roleData.policies.includes(p);
                        }); // Add new policies
                        if (!(policiesToAdd.length > 0)) {
                            _context.n = 3;
                            break;
                        }
                        policyIdsToAdd = policiesToAdd.map(function (policyName) {
                            var _policies$find;
                            return (_policies$find = policies.find(function (p) {
                                return p.name === policyName;
                            })) === null || _policies$find === void 0 ? void 0 : _policies$find.id;
                        }).filter(function (id) {
                            return id !== undefined;
                        });
                        if (!(policyIdsToAdd.length > 0)) {
                            _context.n = 3;
                            break;
                        }
                        _context.n = 3;
                        return UserAPI.createRolePolicy({
                            role_id: Number.parseInt(selectedRole.id),
                            policy_id: policyIdsToAdd
                        });
                    case 3:
                        if (!(policiesToRemove.length > 0)) {
                            _context.n = 4;
                            break;
                        }
                        policyIdsToRemove = policiesToRemove.map(function (policyName) {
                            var _policies$find2;
                            return (_policies$find2 = policies.find(function (p) {
                                return p.name === policyName;
                            })) === null || _policies$find2 === void 0 ? void 0 : _policies$find2.id;
                        }).filter(function (id) {
                            return id !== undefined;
                        });
                        if (!(policyIdsToRemove.length > 0)) {
                            _context.n = 4;
                            break;
                        }
                        _context.n = 4;
                        return UserAPI.removeSpecificPoliciesFromRole(selectedRole.id, policyIdsToRemove);
                    case 4:
                        return _context.a(2);
                }
        }, _callee);
    }));
    return function handleExistingRolePolicyUpdates(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
    };
}();
// Helper function to assign policies to new role
var assignPoliciesToNewRole = /*#__PURE__*/ function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee2(roleData, newRole, policies) {
        var _roleData$policies;
        var selectedPolicyIds;
        return _regenerator().w(function (_context2) {
            while (1)
                switch (_context2.n) {
                    case 0:
                        if (!(!((_roleData$policies = roleData.policies) !== null && _roleData$policies !== void 0 && _roleData$policies.length) || !newRole.id)) {
                            _context2.n = 1;
                            break;
                        }
                        return _context2.a(2);
                    case 1:
                        selectedPolicyIds = roleData.policies.map(function (policyName) {
                            var _policies$find3;
                            return (_policies$find3 = policies.find(function (p) {
                                return p.name === policyName;
                            })) === null || _policies$find3 === void 0 ? void 0 : _policies$find3.id;
                        }).filter(function (id) {
                            return id !== undefined;
                        });
                        if (!(selectedPolicyIds.length > 0)) {
                            _context2.n = 3;
                            break;
                        }
                        _context2.n = 2;
                        return UserAPI.createRolePolicy({
                            role_id: Number.parseInt(newRole.id),
                            policy_id: selectedPolicyIds
                        });
                    case 2:
                        newRole.policies = roleData.policies;
                    case 3:
                        return _context2.a(2);
                }
        }, _callee2);
    }));
    return function assignPoliciesToNewRole(_x4, _x5, _x6) {
        return _ref2.apply(this, arguments);
    };
}();
// Helper function to update existing role
var updateExistingRole = /*#__PURE__*/ function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee3(roleData, selectedRole, policies, loadInitialData) {
        var appIds, updateRequest, _t;
        return _regenerator().w(function (_context3) {
            while (1)
                switch (_context3.p = _context3.n) {
                    case 0:
                        if (validateRoleForUpdate(selectedRole)) {
                            _context3.n = 1;
                            break;
                        }
                        throw new Error('Missing required role information. Unable to update role.');
                    case 1:
                        // Always send application_id as array (empty array for 'None' option)
                        appIds = normalizeAppIds(roleData.application_id);
                        updateRequest = {
                            organization_id: Number.parseInt(selectedRole.organization_id || ''),
                            application_id: appIds,
                            role_name: roleData.name,
                            role_key: roleData.name.toLowerCase().replaceAll(/\s+/g, '_')
                        };
                        _context3.n = 2;
                        return UserAPI.updateRole(selectedRole.id || '', updateRequest);
                    case 2:
                        _context3.p = 2;
                        _context3.n = 3;
                        return handleExistingRolePolicyUpdates(roleData, selectedRole, policies);
                    case 3:
                        _context3.n = 5;
                        break;
                    case 4:
                        _context3.p = 4;
                        _t = _context3.v;
                        console.warn('Failed to update policies for role:', _t);
                    case 5:
                        _context3.n = 6;
                        return loadInitialData();
                    case 6:
                        return _context3.a(2);
                }
        }, _callee3, null, [[2, 4]]);
    }));
    return function updateExistingRole(_x7, _x8, _x9, _x0) {
        return _ref3.apply(this, arguments);
    };
}();
// Helper function to create new role
var createNewRole = /*#__PURE__*/ function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee4(roleData, selectedApplication, applications, policies) {
        var _selectedApp$organiza, _applications$;
        var selectedAppIds, selectedApp, organizationId, createRequest, response, newRole, _t2;
        return _regenerator().w(function (_context4) {
            while (1)
                switch (_context4.p = _context4.n) {
                    case 0:
                        // Use all selected application IDs from roleData
                        selectedAppIds = normalizeAppIds(roleData.application_id); // Find the first selected application to get organization_id (or use default for 'None')
                        selectedApp = applications.find(function (app) {
                            return selectedAppIds.includes(String(app.id));
                        }); // Use organization_id from app if available, otherwise use first available app's org_id
                        organizationId = (_selectedApp$organiza = selectedApp === null || selectedApp === void 0 ? void 0 : selectedApp.organization_id) !== null && _selectedApp$organiza !== void 0 ? _selectedApp$organiza : (_applications$ = applications[0]) === null || _applications$ === void 0 ? void 0 : _applications$.organization_id;
                        if (organizationId) {
                            _context4.n = 1;
                            break;
                        }
                        throw new Error('No organization available. Please ensure at least one application exists.');
                    case 1:
                        createRequest = {
                            organization_id: organizationId,
                            application_id: selectedAppIds,
                            role_name: roleData.name,
                            role_key: roleData.name.toLowerCase().replaceAll(/\s+/g, '_')
                        };
                        _context4.n = 2;
                        return UserAPI.createRole(createRequest);
                    case 2:
                        response = _context4.v;
                        newRole = {
                            id: response.role_id || Date.now().toString(),
                            name: response.role_name || roleData.name,
                            application_id: normalizeAppIds(response.application_id).length > 0 ? normalizeAppIds(response.application_id) : selectedAppIds,
                            role_key: response.role_key || roleData.name.toLowerCase().replaceAll(/\s+/g, '_'),
                            policies: [],
                            peopleAssigned: 0,
                            dateAdded: new Date().toLocaleDateString('en-US', {
                                month: 'short',
                                day: 'numeric',
                                year: 'numeric'
                            })
                        }; // Assign policies to new role
                        _context4.p = 3;
                        _context4.n = 4;
                        return assignPoliciesToNewRole(roleData, newRole, policies);
                    case 4:
                        _context4.n = 6;
                        break;
                    case 5:
                        _context4.p = 5;
                        _t2 = _context4.v;
                        console.warn('Failed to assign policies to new role:', _t2);
                    case 6:
                        return _context4.a(2, newRole);
                }
        }, _callee4, null, [[3, 5]]);
    }));
    return function createNewRole(_x1, _x10, _x11, _x12) {
        return _ref4.apply(this, arguments);
    };
}();
var RoleManagement = function RoleManagement() {
    var _roleToDelete$name;
    var _useThemeDetails = useThemeDetails(), stateImages = _useThemeDetails.stateImages;
    var _useState = useState([]), _useState2 = _slicedToArray(_useState, 2), roles = _useState2[0], setRoles = _useState2[1];
    var _useState3 = useState([]), _useState4 = _slicedToArray(_useState3, 2), applications = _useState4[0], setApplications = _useState4[1];
    var _useState5 = useState([]), _useState6 = _slicedToArray(_useState5, 2), policies = _useState6[0], setPolicies = _useState6[1];
    var _useState7 = useState(''), _useState8 = _slicedToArray(_useState7, 2), selectedApplication = _useState8[0], setSelectedApplication = _useState8[1];
    var _useState9 = useState(true), _useState0 = _slicedToArray(_useState9, 2), dataLoading = _useState0[0], setDataLoading = _useState0[1];
    var _useState1 = useState(null), _useState10 = _slicedToArray(_useState1, 2), error = _useState10[0], setError = _useState10[1];
    // Modal and dialog state
    var _useState11 = useState(false), _useState12 = _slicedToArray(_useState11, 2), roleModalOpen = _useState12[0], setRoleModalOpen = _useState12[1];
    var _useState13 = useState(null), _useState14 = _slicedToArray(_useState13, 2), selectedRole = _useState14[0], setSelectedRole = _useState14[1];
    var _useState15 = useState(false), _useState16 = _slicedToArray(_useState15, 2), deleteDialogOpen = _useState16[0], setDeleteDialogOpen = _useState16[1];
    var _useState17 = useState(null), _useState18 = _slicedToArray(_useState17, 2), roleToDelete = _useState18[0], setRoleToDelete = _useState18[1];
    var _useState19 = useState(false), _useState20 = _slicedToArray(_useState19, 2), loading = _useState20[0], setLoading = _useState20[1];
    var _useState21 = useState(''), _useState22 = _slicedToArray(_useState21, 2), successMessage = _useState22[0], setSuccessMessage = _useState22[1];
    // Load data on component mount
    useEffect(function () {
        loadInitialData();
    }, []);
    var loadInitialData = /*#__PURE__*/ function () {
        var _ref5 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee5() {
            var _yield$Promise$all, _yield$Promise$all2, apps, rolesWithDataResponse, policiesResponse, transformedRoles, appList, _t3;
            return _regenerator().w(function (_context5) {
                while (1)
                    switch (_context5.p = _context5.n) {
                        case 0:
                            setDataLoading(true);
                            setError(null);
                            _context5.p = 1;
                            _context5.n = 2;
                            return Promise.all([UserAPI.getAllApplications(), UserAPI.getRolesWithPoliciesAndCounts(), UserAPI.getPolicies()]);
                        case 2:
                            _yield$Promise$all = _context5.v;
                            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 3);
                            apps = _yield$Promise$all2[0];
                            rolesWithDataResponse = _yield$Promise$all2[1];
                            policiesResponse = _yield$Promise$all2[2];
                            setApplications(apps.resource || apps);
                            // Transform the aggregated role data to match the existing format
                            transformedRoles = rolesWithDataResponse.resource.map(function (role) {
                                return {
                                    id: role.role_id,
                                    name: role.role_name,
                                    application_id: normalizeAppIds(role.application_id),
                                    organization_id: role.organization_id,
                                    role_key: role.role_key,
                                    policies: role.policies.map(function (policy) {
                                        return policy.policy_name;
                                    }),
                                    // Extract policy names
                                    peopleAssigned: role.assignment_count,
                                    dateAdded: formatRoleDate(role.metadata)
                                };
                            });
                            setRoles(transformedRoles);
                            setPolicies(policiesResponse.resource);
                            // Set default application filter to first application if available
                            appList = apps.resource || apps;
                            if (Array.isArray(appList) && appList.length > 0) {
                                setSelectedApplication(appList[0].name);
                            }
                            _context5.n = 4;
                            break;
                        case 3:
                            _context5.p = 3;
                            _t3 = _context5.v;
                            console.error('Failed to load data:', _t3);
                            setError(constants.role_mgmt_error_load_data);
                            setRoles([]);
                        case 4:
                            _context5.p = 4;
                            setDataLoading(false);
                            return _context5.f(4);
                        case 5:
                            return _context5.a(2);
                    }
            }, _callee5, null, [[1, 3, 4, 5]]);
        }));
        return function loadInitialData() {
            return _ref5.apply(this, arguments);
        };
    }();
    var handleAddRole = function handleAddRole() {
        if (!selectedApplication) {
            setError(constants.role_mgmt_select_app_before_create);
            return;
        }
        setSelectedRole(null);
        setRoleModalOpen(true);
    };
    var handleEditRole = function handleEditRole(role) {
        setSelectedRole(role);
        setRoleModalOpen(true);
    };
    var handleDeleteRole = function handleDeleteRole(role) {
        setRoleToDelete(role);
        setDeleteDialogOpen(true);
    };
    var handleSaveRole = /*#__PURE__*/ function () {
        var _ref6 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee6(roleData) {
            var newRole, _t4;
            return _regenerator().w(function (_context6) {
                while (1)
                    switch (_context6.p = _context6.n) {
                        case 0:
                            setLoading(true);
                            setError(null);
                            _context6.p = 1;
                            if (!selectedRole) {
                                _context6.n = 3;
                                break;
                            }
                            _context6.n = 2;
                            return updateExistingRole(roleData, selectedRole, policies, loadInitialData);
                        case 2:
                            setSuccessMessage(constants.role_mgmt_update_success);
                            _context6.n = 5;
                            break;
                        case 3:
                            _context6.n = 4;
                            return createNewRole(roleData, selectedApplication, applications, policies);
                        case 4:
                            newRole = _context6.v;
                            setRoles(function (prevRoles) {
                                return [].concat(_toConsumableArray(prevRoles), [newRole]);
                            });
                            setSuccessMessage(constants.role_mgmt_add_success);
                        case 5:
                            setRoleModalOpen(false);
                            setSelectedRole(null);
                            _context6.n = 7;
                            break;
                        case 6:
                            _context6.p = 6;
                            _t4 = _context6.v;
                            console.error('Error saving role:', _t4);
                            setError(_t4 instanceof Error ? _t4.message : constants.role_mgmt_error_save_role);
                        case 7:
                            _context6.p = 7;
                            setLoading(false);
                            return _context6.f(7);
                        case 8:
                            return _context6.a(2);
                    }
            }, _callee6, null, [[1, 6, 7, 8]]);
        }));
        return function handleSaveRole(_x13) {
            return _ref6.apply(this, arguments);
        };
    }();
    var confirmDeleteRole = /*#__PURE__*/ function () {
        var _ref7 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee7() {
            var _t5;
            return _regenerator().w(function (_context7) {
                while (1)
                    switch (_context7.p = _context7.n) {
                        case 0:
                            if (!roleToDelete) {
                                _context7.n = 7;
                                break;
                            }
                            setLoading(true);
                            setError(null);
                            _context7.p = 1;
                            if (roleToDelete.id) {
                                _context7.n = 2;
                                break;
                            }
                            throw new Error('Role ID is required for deletion');
                        case 2:
                            _context7.n = 3;
                            return UserAPI.deleteAllRolePolicies(roleToDelete.id);
                        case 3:
                            _context7.n = 4;
                            return UserAPI.deleteRole(roleToDelete.id);
                        case 4:
                            setRoles(function (prevRoles) {
                                return prevRoles.filter(function (r) {
                                    return r.id !== roleToDelete.id;
                                });
                            });
                            setSuccessMessage(constants.role_mgmt_delete_success);
                            setDeleteDialogOpen(false);
                            setRoleToDelete(null);
                            _context7.n = 6;
                            break;
                        case 5:
                            _context7.p = 5;
                            _t5 = _context7.v;
                            console.error('Error deleting role:', _t5);
                            setError(constants.role_mgmt_error_delete_role);
                        case 6:
                            _context7.p = 6;
                            setLoading(false);
                            return _context7.f(6);
                        case 7:
                            return _context7.a(2);
                    }
            }, _callee7, null, [[1, 5, 6, 7]]);
        }));
        return function confirmDeleteRole() {
            return _ref7.apply(this, arguments);
        };
    }();
    // Check view permission
    if (!isAuthorized('RBAC:ViewRole')) {
        return /*#__PURE__*/ React.createElement(Box, {
            sx: {
                p: 3,
                bgcolor: '#f8f8f8'
            }
        }, /*#__PURE__*/ React.createElement(Box, {
            sx: {
                textAlign: 'center',
                py: 8
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h6",
            color: "#666",
            gutterBottom: true
        }, constants.role_mgmt_access_denied_title), /*#__PURE__*/ React.createElement(Typography, {
            variant: "body1",
            color: "#888"
        }, constants.role_mgmt_access_denied_desc)));
    }
    return /*#__PURE__*/ React.createElement(Box, {
        sx: {
            p: 3,
            bgcolor: '#f8f8f8'
        }
    }, /*#__PURE__*/ React.createElement(Paper, {
        sx: {
            p: 3,
            borderRadius: 2,
            boxShadow: 'none'
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 3
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        sx: {
            mb: 3
        }
    }, constants.role_mgmt_header_description), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            gap: 2,
            alignItems: 'center'
        }
    }, /*#__PURE__*/ React.createElement(FormControl, {
        size: "small",
        sx: {
            minWidth: 200
        }
    }, /*#__PURE__*/ React.createElement(InputLabel, null, constants.policy_mgmt_application_label), /*#__PURE__*/ React.createElement(Select, {
        value: selectedApplication,
        onChange: function onChange(e) {
            return setSelectedApplication(e.target.value);
        },
        label: constants.policy_mgmt_application_label,
        disabled: dataLoading
    }, /*#__PURE__*/ React.createElement(MenuItem, {
        value: "none"
    }, constants.global_roles), applications.map(function (app) {
        return /*#__PURE__*/ React.createElement(MenuItem, {
            key: app.id || app.name,
            value: app.name
        }, app.name);
    }))), isAuthorized('RBAC:CreateRole') && /*#__PURE__*/ React.createElement(Button, {
        variant: "contained",
        startIcon: /*#__PURE__*/ React.createElement(AddIcon, null),
        onClick: handleAddRole,
        sx: {
            textTransform: 'none',
            boxShadow: 'none'
        }
    }, constants.role_mgmt_add_button))), dataLoading && /*#__PURE__*/ React.createElement(Box, {
        sx: {
            textAlign: 'center',
            py: 4
        }
    }, stateImages !== null && stateImages !== void 0 && stateImages.Loading ? /*#__PURE__*/ React.createElement(Box, {
        component: "img",
        src: stateImages.Loading,
        alt: "Loading",
        sx: {
            width: 128,
            height: 128
        }
    }) : /*#__PURE__*/ React.createElement(CircularProgress, null), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            mt: 2
        }
    }, constants.role_mgmt_loading)), error && /*#__PURE__*/ React.createElement(Alert, {
        severity: "error",
        sx: {
            mb: 3
        }
    }, error), successMessage && /*#__PURE__*/ React.createElement(Alert, {
        severity: "success",
        sx: {
            mb: 3
        },
        onClose: function onClose() {
            return setSuccessMessage('');
        }
    }, successMessage), !dataLoading && !error && /*#__PURE__*/ React.createElement(TableContainer, null, /*#__PURE__*/ React.createElement(Table, null, /*#__PURE__*/ React.createElement(TableHead, null, /*#__PURE__*/ React.createElement(TableRow, null, /*#__PURE__*/ React.createElement(TableCell, {
        sx: {
            color: '#212121',
            borderBottom: '1px solid #ebebeb',
            width: '270px'
        }
    }, /*#__PURE__*/ React.createElement(Stack, {
        direction: "row",
        alignItems: "center",
        gap: 1
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            fontWeight: 600
        }
    }, constants.role_mgmt_table_header_name), /*#__PURE__*/ React.createElement(FilterIcon, {
        sx: {
            fontSize: 18,
            color: '#26890d'
        }
    }))), /*#__PURE__*/ React.createElement(TableCell, {
        sx: {
            color: '#212121',
            borderBottom: '1px solid #ebebeb'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            fontWeight: 600
        }
    }, constants.role_mgmt_table_header_policies_assigned)), /*#__PURE__*/ React.createElement(TableCell, {
        sx: {
            color: '#212121',
            borderBottom: '1px solid #ebebeb'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            fontWeight: 600
        }
    }, constants.role_mgmt_table_header_people_assigned)), /*#__PURE__*/ React.createElement(TableCell, {
        sx: {
            color: '#212121',
            borderBottom: '1px solid #ebebeb'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            fontWeight: 600
        }
    }, constants.role_mgmt_table_header_date_added)), /*#__PURE__*/ React.createElement(TableCell, {
        sx: {
            color: '#212121',
            borderBottom: '1px solid #ebebeb',
            width: '200px'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            fontWeight: 600
        }
    }, constants.role_mgmt_table_header_actions)))), /*#__PURE__*/ React.createElement(TableBody, null, function () {
        // Filter roles based on selected application
        var filteredRoles = roles.filter(function (role) {
            if (!selectedApplication)
                return true;
            // Handle "None" option - show roles without application_id
            if (selectedApplication === 'none') {
                var _appIds = normalizeAppIds(role.application_id);
                return _appIds.every(function (id) {
                    return id === 'null' || id === 'undefined' || id === '';
                });
            }
            // Find the application by name to get its ID
            var selectedApp = applications.find(function (app) {
                return app.name === selectedApplication;
            });
            if (!selectedApp)
                return false;
            // Always treat application_id as array for filtering
            var appIds = normalizeAppIds(role.application_id);
            return appIds.includes(String(selectedApp.id));
        });
        if (filteredRoles.length === 0) {
            return /*#__PURE__*/ React.createElement(TableRow, null, /*#__PURE__*/ React.createElement(TableCell, {
                colSpan: 5,
                sx: {
                    textAlign: 'center',
                    py: 4
                }
            }, /*#__PURE__*/ React.createElement(Typography, {
                variant: "body2",
                color: "text.secondary"
            }, constants.role_mgmt_no_roles_found)));
        }
        return filteredRoles.map(function (role) {
            return /*#__PURE__*/ React.createElement(TableRow, {
                key: role.id
            }, /*#__PURE__*/ React.createElement(TableCell, {
                sx: {
                    borderBottom: '1px solid #ebebeb',
                    py: 2
                }
            }, /*#__PURE__*/ React.createElement(Typography, {
                variant: "body1",
                sx: {
                    fontWeight: 600,
                    color: '#26890d',
                    textDecoration: 'underline',
                    cursor: isAuthorized('RBAC:UpdateRole') ? 'pointer' : 'default',
                    '&:hover': {
                        color: isAuthorized('RBAC:UpdateRole') ? '#1f6b0a' : '#26890d'
                    }
                },
                onClick: function onClick() {
                    return isAuthorized('RBAC:UpdateRole') && handleEditRole(role);
                }
            }, role.name)), /*#__PURE__*/ React.createElement(TableCell, {
                sx: {
                    borderBottom: '1px solid #ebebeb',
                    py: 2
                }
            }, /*#__PURE__*/ React.createElement(Box, {
                sx: {
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 0.5
                }
            }, role.policies.length > 0 ? role.policies.map(function (policy) {
                return /*#__PURE__*/ React.createElement(Chip, {
                    key: policy,
                    label: policy,
                    size: "small",
                    sx: {
                        backgroundColor: '#f3f8eb',
                        color: '#1a5d09',
                        fontFamily: 'Open Sans',
                        fontSize: 12,
                        fontWeight: 600,
                        height: 20
                    }
                });
            }) : /*#__PURE__*/ React.createElement(Chip, {
                label: constants.role_mgmt_chip_no_policies,
                size: "small",
                sx: {
                    backgroundColor: '#ebebeb',
                    color: '#595959',
                    fontFamily: 'Open Sans',
                    fontSize: 12,
                    fontWeight: 600,
                    height: 20
                }
            }))), /*#__PURE__*/ React.createElement(TableCell, {
                sx: {
                    borderBottom: '1px solid #ebebeb',
                    py: 2
                }
            }, /*#__PURE__*/ React.createElement(Typography, {
                variant: "body1",
                color: "#212121"
            }, role.peopleAssigned)), /*#__PURE__*/ React.createElement(TableCell, {
                sx: {
                    borderBottom: '1px solid #ebebeb',
                    py: 2
                }
            }, /*#__PURE__*/ React.createElement(Typography, {
                variant: "body1",
                color: "#212121"
            }, role.dateAdded)), /*#__PURE__*/ React.createElement(TableCell, {
                sx: {
                    borderBottom: '1px solid #ebebeb',
                    py: 2
                }
            }, /*#__PURE__*/ React.createElement(Box, {
                sx: {
                    display: 'flex',
                    gap: 1
                }
            }, isAuthorized('RBAC:UpdateRole') && /*#__PURE__*/ React.createElement(IconButton, {
                onClick: function onClick() {
                    return handleEditRole(role);
                },
                sx: {
                    color: '#26890d',
                    '&:hover': {
                        bgcolor: 'rgba(38, 137, 13, 0.04)'
                    }
                }
            }, /*#__PURE__*/ React.createElement(EditIcon, null)), isAuthorized('RBAC:DeleteRole') && /*#__PURE__*/ React.createElement(IconButton, {
                onClick: function onClick() {
                    return handleDeleteRole(role);
                },
                sx: {
                    color: '#da291c',
                    '&:hover': {
                        bgcolor: 'rgba(218, 41, 28, 0.04)'
                    }
                }
            }, /*#__PURE__*/ React.createElement(DeleteIcon, null)))));
        });
    }())))), /*#__PURE__*/ React.createElement(RoleModal, {
        open: roleModalOpen,
        onClose: function onClose() {
            setRoleModalOpen(false);
            setSelectedRole(null);
        },
        onSave: handleSaveRole,
        role: selectedRole,
        loading: loading,
        applications: applications
    }), /*#__PURE__*/ React.createElement(ConfirmationDialog, {
        isOpen: deleteDialogOpen,
        setIsOpen: function setIsOpen() {
            setDeleteDialogOpen(false);
            setRoleToDelete(null);
        },
        submitFunction: confirmDeleteRole,
        bodyText: constants.role_mgmt_delete_confirm_body((_roleToDelete$name = roleToDelete === null || roleToDelete === void 0 ? void 0 : roleToDelete.name) !== null && _roleToDelete$name !== void 0 ? _roleToDelete$name : ''),
        submitButtonText: constants["delete"],
        loading: loading
    }));
};
export default authenticatedRoute(RoleManagement);
